import {LogCat, LogManager} from "../../../common/log";
import {IAddressEntry} from "../";

/**
	****************************************************************
	* Class for holding address information, with additional details like phone number etc.
	*
	* Written by: Shai Zelman
	****************************************************************
	*/
//@Injectable()
export class AddressList extends Array<IAddressEntry> {
	[index: number]: IAddressEntry;

	constructor() {
		super();
	}

	public addAddress(address: IAddressEntry): void {
		LogManager.debug(LogCat.RisUserContextCategories.Address, "Add new address.");

		this.push(address);
	}

	public get primaryAddress(): IAddressEntry {
		LogManager.debug(LogCat.RisUserContextCategories.Address, "Get primary address.");

		if (this.length === 0) {
			return null;
		}

		let primaryAddress: IAddressEntry[] = this.filter((value: IAddressEntry) => {
			return value.isPrimary;
		});

		return primaryAddress.length > 0 ? primaryAddress[0] : this[0];
	}
}

